import * as types from "./ActionsProductListingReducer";

export default function productListingReducer(
    state = {
        productListing: []
    }, action) {
    switch (action.type) {
        case types.PRODUCT_GET_LISTING:
            state.productListing = action.value;
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/products/ProductListingReducer.ts